<template>
    <v-container id="main_grid">
        <v-layout row wrap>
            <v-flex v-if="!isMobile && isPro" id="add_experience_pad"
                    lg3 md4 sm6 xs12 @click="modeNewExperience">
                <div id="add_experience">
                    <div id="add_experience_content">
                        <i class="fas fa-plus" />
                        <p>Nouvelle expérience</p>
                    </div>
                </div>
            </v-flex>
            <v-flex v-for="(experience,index) in experienceFilter" :key="index"
                    class="card_box" lg3 md4 sm6 xs12>
                <experience-card :experience="experience" />
            </v-flex>
        </v-layout>
        <v-btn v-if="isMobile && isPro" class="mx-2 round_button" dark fab large @click="modeNewExperience">
            <i class="fas fa-plus" />
        </v-btn>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ExperienceGrid',
        components: {
            ExperienceCard: () => import('./ExperienceCard')
        },
        props: {
            sort: {
                type: Function
            },
            search: {
                type: String,
                default: null
            },
            order: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters('app', ['isPro', 'profil', 'isMobile']),
            ...mapGetters('experiences', ['experiences']),
            experienceFilter: function () {
                var res = [...this.experiences];
                res = this.search !== null ? res.filter(item => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase());
                }) : res;
                res = this.sort ? res.sort(this.sort) : res;
                res = this.order ? res.reverse() : res;
                return res;
            }
        },
        mounted () {
            this.loadExperiences().catch((err) => {
                this.$toasted.error(err);
            });
        },
        methods: {
            ...mapActions('experiences', ['modeNewExperience', 'loadExperiences'])
        }
    };
</script>

<style lang="scss" scoped>

    #header_select_box {
        font-size: 1rem;
        padding-left: 20px;
        max-height: 150px;
    }

    .header_button_style {
        height: 50px;
    }

    .header_button_style * {
        top: 0;
        left: 0;
        vertical-align: top;
    }

    #header_button_box {
        background-color: #169CEB;
        color: #FFF;
        top: 18px;
        float: right;
        max-width: 150px;

    }

    #header_button_box.active {
        top: 70vh;
    }

    #head_container {
        padding-left: 10px;
    }

    #main_bar {
        position: relative;
        top: 0;
        left: 0;
        padding-left: 10px;
        padding-right: 10px;
    }

    #main_grid {
        position: relative;
        left: 0;
        float: left;
        margin-bottom: 25px;
        width: 100%;
        max-width: 100%;
    }

    #add_experience {
        background-color: #FFF;
        transition: 0.3s ease;
        cursor: pointer;
        border-radius: 5px;
        height: 100%;
        min-height: 300px;
        overflow: hidden;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);

        i {
            font-size: 50px;
            transition: 0.3s ease;
            color: #169CEB !important;
        }

        p {
            font-size: 15px;
            color: #4A4A4A !important;
        }

        &:hover {
            border: 3px solid #169CEB;

            i {
                transform: rotate(180deg);
                transition: 0.3s ease;
            }
        }
    }

    #add_experience_content {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    #add_experience_pad {
        padding: 10px !important;
    }

    .round_button {
        position: fixed !important;
        top: 50vh;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        right: 0;
        z-index: 1;
        background-color: #169CEB !important;
    }

    .round_button i {
        color: white;
        font-size: 35px;
        font-weight: bold;
        position: relative;
    }

    .card_box {
        padding: 10px !important;
        transition: transform 0.2s;
    }

    .card_box:hover {
        transform: scale(1.025);
        transition: transform 0.2s;
    }

    .custom_sorting {
        border-radius: 3px;
        margin-bottom: -15px;
        margin-left: 10px;
        margin-right: 10px;
    }
</style>
